module.exports = __webpack_public_path__ + "static/media/3.0e638b65.png";